import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e4dcb3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "footer",
  class: "wrapper"
}
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["onClick", "href", "target"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "list language" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.footerList, (list, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "list",
        key: i
      }, [
        _createElementVNode("h3", {
          class: "header",
          textContent: _toDisplayString(list.title)
        }, null, 8, _hoisted_2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.content, (item, j) => {
          return (_openBlock(), _createElementBlock("div", {
            key: j,
            class: _normalizeClass(["items", {'--icon': item.icon}])
          }, [
            _createElementVNode("a", {
              class: "link",
              onClick: ($event: any) => ($setup.onLinkClicked(item)),
              href: item.link,
              target: item.external ? '_blank' : '_self'
            }, [
              (item.text)
                ? (_openBlock(), _createElementBlock("h5", {
                    key: 0,
                    class: "fw6",
                    textContent: _toDisplayString(item.text)
                  }, null, 8, _hoisted_4))
                : (item.icon)
                  ? (_openBlock(), _createBlock(_component_SvgIcon, {
                      key: 1,
                      "icon-name": item.icon,
                      class: "icon"
                    }, null, 8, ["icon-name"]))
                  : _createCommentVNode("", true)
            ], 8, _hoisted_3)
          ], 2))
        }), 128))
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_SvgIcon, {
        class: "lang-icon",
        "icon-name": "language"
      }),
      _createVNode(_component_Tabs, {
        headers: $setup.langList,
        selected: $setup.lang,
        "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => (($setup.lang) = $event)),
        small: true
      }, null, 8, ["headers", "selected"])
    ])
  ]))
}